module.exports = __webpack_public_path__ + "media/customizations/emberly/logo-1a70d37e9ac0314215e22510732177c9.png";